/* eslint-disable jsx-a11y/alt-text */
import { useEffect, useState } from "react";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import Male from "../../../assets/images/male.png";
import { closeDialog } from "../../../redux/slice/dialogueSlice";
import { getFetchWalletData, getUser } from "../../../redux/slice/userSlice";
import { isLoading } from "../../../util/allSelector";
import Analytics from "../../extras/Analytics";
import { ExInput, Textarea } from "../../extras/Input";
import Pagination from "../../extras/Pagination";
import Table from "../../extras/Table";

const UserProfile = () => {
  const { userProfile, fetchWalletData, totalWalletData } = useSelector((state) => state.user);
  const { state } = useLocation();
  const { setting } = useSelector((state) => state.setting);

  const dispatch = useDispatch();
  const [data, setData] = useState([]);
  const [userData, setUserData] = useState([]);
  const navigate = useNavigate();
  const loader = useSelector(isLoading);
  const [transactionType, setTransactionType] = useState("All");
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const [startDate, setStartDate] = useState("ALL");
  const [endDate, setEndDate] = useState("ALL");

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event, 10));
    setPage(0);
  };
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);
  useEffect(() => {
    dispatch(getUser(state?.id));
  }, [state]);

  useEffect(() => {
    // if (walletDetails) {
    //   const payload = {
    //     startDate: startDate,
    //     endDate: endDate,
    //     start: page,
    //     limit: rowsPerPage,
    //     type: transactionType
    //   }
    //   dispatch(getWalletData(payload))
    // } else {
    const payload = {
      startDate: startDate === "ALL" ? "All" : startDate,
      userId: state?.id,
      endDate: endDate === "ALL" ? "All" : endDate,
      start: page,
      limit: rowsPerPage,
      type: transactionType
    }
    dispatch(getFetchWalletData(payload))
    // }
  }, [startDate, page, rowsPerPage, transactionType])




  useEffect(() => {
    setUserData(userProfile);
  }, [userProfile]);
  // useEffect(() => {
  //   setData(walletData)
  // }, [walletData])
  useEffect(() => {
    setData(fetchWalletData)
  }, [fetchWalletData])

  const transactionTypeData = [
    { value: "1", label: "Credit" },
    { value: "2", label: "Debit" }
  ]

  console.log("fetchWalletData", fetchWalletData)

  const handelPreviousPage = () => {
    if (state) {
      navigate(-1);
    } else {
      sessionStorage.removeItem("dialogueData");
      dispatch({ type: closeDialog });
    }
  };
  const walletTable = [
    {
      Header: "No",
      Cell: ({ index }) => (
        <span>{page * rowsPerPage + parseInt(index) + 1}</span>
      ),
    },
    {
      Header: "UniqueId",
      Cell: ({ row }) => (
        <span
          className="text-capitalize  cursor"
        >
          {row?.uniqueId}
        </span>
      ),
    },
    {
      Header: `Amount (${setting?.currencySymbol || "$"})`,
      Cell: ({ row }) => <span className="text-capitalize">{row?.amount || "-"}</span>,
    },
    {
      Header: "Date",
      Cell: ({ row }) => (
        <span
          className="text-capitalize  cursor"
        >
          {row?.date
            ? row?.date
            : "-"}
        </span>
      ),
    },

    {
      Header: "Time",
      Cell: ({ row }) => (
        <div>
          {row?.time ? row?.time : "-"}
        </div>
      ),
    },
    {
      Header: "Transaction Type",
      Cell: ({ row }) =>
        row?.type === 1 ? (
          <button className="badge-success " >
            Credit
          </button>
        ) : row?.type === 2 || row?.type === 3 ? (
          <button className="badge-danger " >
            Debit
          </button>
        ) : row?.type === 4 ? (
          <button className="badge-danger ">
            Debit
          </button>
        ) : row?.type === 5 ? (
          <button className="badge-success ">
            Credit
          </button>
        ) : row?.type === "All" ? (
          <button
            className="badge-info "

          >
            All
          </button>
        ) : (
          ""
        ),
    },
    {
      Header: "Transaction Completed",
      Cell: ({ row }) =>
        row?.type === 1 ? (
          <button className="badge-success">
             Wallet Deposit
          </button>
        ) : row?.type === 2 ? (

          <button
            className="badge-warning"
            
          >
            Booking Fee Deduction
          </button>
        ) : row?.type === 3 ? (

          <button className="badge-primary">
            
            Product Purchase Deduction
          </button>
        ) : row?.type === 4 ? (
          <button className="badge-danger">
           
            Order Cancellation Fee
          </button>
        ) : row?.type === 5 ? (
          <button className="badge-info">
            
            Order Refund
          </button>
        ) : (
          ""
        ),
    },
  ];
  return (
    <div className="userPage">
      {/* {loader === true ? (
        <>
          <SkeletonTheme baseColor="#e2e5e7" highlightColor="#fff">
            <div className="col-xl-2 col-md-3 col-sm-4">
              <Skeleton height={30} />
            </div>
          </SkeletonTheme>
        </>
      ) : (
        <Title
          name={`${data?.fname ? data?.fname + ` ` + data?.lname : "User"
            }'s   Profile`}
        />
      )} */}
      {/* <div className="col-7 my-auto ms-auto justify-content-end d-flex pe-3">
        <Button
          className={`bg-danger  text-center text-white mt-3`}
          onClick={handelPreviousPage}
          style={{
            borderRadius: "5px",
          }}
          bIcon={`fa-solid fa-angles-left text-white fs-20 m-auto`}
          text="Back"
        />
      </div> */}
      <div className="boxShadow">
        <div
          className="position-relative  rounded-2 px-4 w-100"
          style={{ height: "180px", backgroundColor: "#eee" }}
        >
          <div className="bg-theme w-100">
            {loader === true ? (
              <>
                <SkeletonTheme baseColor="#e2e5e7" highlightColor="#fff">
                  <p className="d-flex justify-content-center ">
                    <Skeleton
                      className="mx-auto  position-absolute"
                      style={{
                        width: 160,
                        height: 160,
                        objectFit: "cover",
                        borderRadius: "50%",
                        top: "88px",
                        left: "50px",
                        backgroundColor: "#FFFFFF",
                        padding: "5px",
                      }}
                    />
                  </p>
                </SkeletonTheme>
              </>
            ) : (
              <img
                src={userData?.image ? userData.image : Male}
                onError={(e) => {
                  e.target.src = Male;
                }}
                alt="User"
                className="mx-auto  position-absolute"
                style={{
                  width: 160,
                  height: 160,
                  objectFit: "cover",
                  borderRadius: "50%",
                  top: "88px",
                  left: "50px",
                  backgroundColor: "#FFFFFF",
                  padding: "5px",
                }}
              />
            )}
          </div>
        </div>
        <div className="row" style={{ marginTop: "75px" }}>
          {loader === true ? (
            <>
              <SkeletonTheme baseColor="#e2e5e7" highlightColor="#fff">
                {[1, 2, 3, 4, 5, 6, 7, 8].map((index) => (
                  <div key={index} className="col-xl-4 col-md-6 col-sm-12">
                    <Skeleton height={40} className="mt-3" />
                  </div>
                ))}
              </SkeletonTheme>
            </>
          ) : (
            <>
              <div className="col-xl-4 col-md-6 col-sm-12">
                <ExInput
                  type={`text`}
                  value={userData?.fname}
                  label={`First name`}
                  readOnly={true}
                />
              </div>
              <div className="col-xl-4 col-md-6 col-sm-12">
                <ExInput
                  type={`text`}
                  value={userData?.lname ? userData?.lname : "-"}
                  label={`Last name`}
                  readOnly={true}
                />
              </div>
              <div className="col-xl-4 col-md-6 col-sm-12">
                <ExInput
                  type={`text`}
                  value={userData?.uniqueId}
                  label={`Unique id`}
                  readOnly={true}
                />
              </div>
              <div className="col-xl-4 col-md-6 col-sm-12">
                <ExInput
                  type={`text`}
                  value={userData?.mobile ? userData?.mobile : "-"}
                  label={`Mobile number`}
                  readOnly={true}
                />
              </div>
              <div className="col-xl-4 col-md-6 col-sm-12">
                <ExInput
                  type={`text`}
                  value={userData?.gender}
                  label={`Gender`}
                  readOnly={true}
                />
              </div>
              <div className="col-xl-4 col-md-6 col-sm-12">
                <ExInput
                  type={`text`}
                  value={userData?.age ? userData?.age : "-"}
                  label={`Age`}
                  readOnly={true}
                />
              </div>
              <div className="col-xl-4 col-md-6 col-sm-12">
                <ExInput
                  type={`text`}
                  value={userData?.email ? userData?.email : "-"}
                  label={`Email id`}
                  readOnly={true}
                />
              </div>
              <div className="col-xl-4 col-md-6 col-sm-12">
                <ExInput
                  type={`text`}
                  value={
                    userData?.loginType == 1
                      ? "Email Login"
                      : userData?.loginType == 2
                        ? "Google Login"
                        : "Mobile Login"
                  }
                  label={`Login type`}
                  readOnly={true}
                  placeholder={`Login Type`}
                />
              </div>
            </>
          )}
        </div>
        <div className="col-12">
          {/* {loader === true ? (
            <>
              <SkeletonTheme
                baseColor="#e2e5e7"
                highlightColor="#fff"
                className="mb-5 mt-3"
              >
                <Skeleton className="mt-5" height={142} />
              </SkeletonTheme>
            </>
          ) : (
            <>
              <label>Bio</label>
              <textarea
                value={data?.bio ? data?.bio : "-"}
                readOnly
                style={{ width: "100%", resize: "none" }}
                cols="30"
                rows={2}
              />
            </>
          )} */}
          <Textarea
            id={`bio`}
            name={`Bio`}
            value={data?.bio}
            row={3}
            label={`Bio`}
            placeholder={`Bio`}
            disabled={true}
          // errorMessage={error.about && error.about}
          />
        </div>

        <div className="d-flex justify-content-end my-4">
          <Analytics
            analyticsStartDate={startDate}
            analyticsStartEnd={endDate}
            placeholder="Wallet"
            analyticsStartDateSet={setStartDate}
            analyticsStartEndSet={setEndDate}
          />
        </div>

        <div className="userPage p-0">
          <div className="user-table mb-3">
            <div className="user-table-top">
              <div className=" d-flex justify-content-between align-items-center w-100 ">
                <div className="w-100">
                  <h5
                    className="main-title">
                    Wallet History
                  </h5>
                </div>
                <div className="d-flex gap-2 justify-content-end w-100">
                  <div className="inputData w-25">
                    <select
                      name="transactionType"
                      className=" form-select"
                      id="transactionType"
                      value={transactionType}
                      onChange={(e) => {
                        const selectedSalonId = e.target.value;
                        const payload = {
                          startDate: startDate,
                          endDate: endDate,
                          start: page,
                          limit: rowsPerPage,
                          type: selectedSalonId
                        }
                        setTransactionType(selectedSalonId);
                        // dispatch(getWalletData(payload))
                      }}
                    >
                      <option key="All" value="All">
                        ALL
                      </option>
                      {transactionTypeData?.map((data) => (
                        <option key={data?.value} value={data?.value}>
                          {data?.label}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
            </div>
            {/* <div className="row">
            <Title name="Wallet History" className="mt-4" onClick={(e) => {
              // setOrderDetails(false);
              // setWalletDetails(true);
              setTransactionType("All");
              setStartDate("All");
              setEndDate("All");
            }} />
          </div> */}
            {/* <div className="betBox">
            <div className="inputData pb-2 pt-2">
              <label className="styleForTitle" htmlFor="transactionType">
                Transaction Type
              </label>
              <select
                name="transactionType"
                className="rounded-2 form-control"
                id="transactionType"
                value={transactionType}
                onChange={(e) => {
                  console.log("eeeeee", e)
                  const selectedSalonId = e.target.value;
                  const payload = {
                    startDate: startDate,
                    endDate: endDate,
                    start: page,
                    limit: rowsPerPage,
                    type: selectedSalonId
                  }
                  setTransactionType(selectedSalonId);
                  // dispatch(getWalletData(payload))
                }}
              >
                <option key="All" value="All">
                  ALL
                </option>
                {transactionTypeData?.map((data) => (
                  <option key={data?.value} value={data?.value}>
                    {data?.label}
                  </option>
                ))}
              </select>
            </div>
            <div className="col-md-9"  >
              <div className="inputData">
                <label>Analytic</label>
              </div>
              <Analytics
                analyticsStartDate={startDate}
                analyticsStartEnd={endDate}
                placeholder="Wallet"
                analyticsStartDateSet={setStartDate}
                analyticsStartEndSet={setEndDate}
              />
            </div>
          </div> */}

            <Table
              data={data}
              rowsPerPage={rowsPerPage}
              page={page}
              mapData={walletTable}
            />
            <Pagination
              type={"server"}
              serverPage={page}
              setServerPage={setPage}
              serverPerPage={rowsPerPage}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              totalData={totalWalletData}
            />
          </div>
        </div>

      </div>

    </div>
  );
};

export default UserProfile;
